// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"34986b97","990":"60d9c670"}[chunkId] + ".chunk.js";
};